import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'padThreshold'})
export class PadThresholdPipe implements PipeTransform {

  constructor (){}

  transform(time: any): string {
    let format = '00:00';

    while(time.length < format.length) {
      time = '0' + time;
    }

    return time;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/threshold/padThreshold.pipe.ts